module.exports = __webpack_public_path__ + "static/media/marker.6c1eedb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RootMap/marker.svg
// module id = 1008
// module chunks = 0